<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconClock_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m5.312 12.917a1.07 1.07 0 0 1-1.455.423l-4.374-2.401a1.07 1.07 0 0 1-.556-.939V4.857a1.07 1.07 0 1 1 2.142 0v6.509l3.818 2.096c.521.285.711.936.425 1.455"
    />
</svg>
